import React, {Component} from "react";
import PropTypes from 'prop-types'
import './index.css'

class Group extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: props?.defaultTab || (props?.tabs ? props?.tabs[0].id : null),
        };
    }

    static defaultProps = {
        className: null,
        title: null,
        description: null,
        tabs: null,
        defaultTab: null,
        onTabChange: _ => null
    };

    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        tabs: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.string, title: PropTypes.string, disable: PropTypes.bool})),
        defaultTab: PropTypes.string,
        onTabChange: PropTypes.func
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }

    render() {
        const cls = ['Group', this.props.className];

        return <div className={cls.join(' ')}>
            {this.props.tabs && <div className={'Group-tab'}>
                {this.props.tabs.map((item, index) => {
                    return <button key={index} className={`Group-tab-button ${item.id == this.state.selected ? 'selected' : ''}`} id={item.id} disabled={item.disable} onClick={this.tabClickHandler.bind(this, item.id)}>{item.title}</button>;
                })}
            </div>}
            {this.props.title && <GroupHead title={this.props.title}/>}
            {this.props.description && <GroupDescription>{this.props.description}</GroupDescription>}
            {!this.props.tabs && <div className="Group-content">{this.props.children}</div>}
            {this.props.tabs && this.props.children.map((child, index) => {
                const props = {...child.props};

                // eslint-disable-next-line eqeqeq
                props.selected = props.id == this.state.selected;
                props.key = index;

                return React.cloneElement(child, props);
            })}
        </div>;
    }

    goto(id) {
        // eslint-disable-next-line eqeqeq
        if (id != this.state.id) {
            this.setState({selected: id});
            this.props.onTabChange(id);
        }
    }

    tabClickHandler(selected) {
        // eslint-disable-next-line eqeqeq
        if (selected != this.state.id) {
            this.setState({selected});
            this.props.onTabChange(selected);
        }
    }
}

const GroupHead = props => <div className={'Group-head'}>
    {props.title && <div className="Group-title">{props.title}</div>}
    {props.children}
</div>;

const GroupDescription = props => <p className="Group-description">{props.children}</p>;

const GroupTabContent = props => <div className={`GroupTabContent ${props.selected ? 'selected' : ''}`} id={props.id}>{props.children}</div>;

export default Group
export {GroupHead, GroupDescription, GroupTabContent}